import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import './InstructorLogin.css';

const InstructorResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');

    if (!token) {
      setMsg('Invalid or missing reset token. Please request a new link.');
      return;
    }
    if (password.length < 8) {
      setMsg('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setMsg('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/instructor-auth/reset-password', {
        token,
        password,
        confirm_password: confirmPassword,
      });
      setMsg(res.data?.message || 'Password updated successfully!');
      setIsSuccess(true);
    } catch (err) {
      setMsg(err.response?.data?.message || err.message || 'Failed to reset password. The link may have expired.');
      setIsSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="il-page">
      <div className="il-brand">
        <span className="il-brand-dot" />
        <span className="il-brand-text">Fast Track <strong>Driving School</strong></span>
      </div>

      <div className="il-card">
        <div className="il-header">
          <div className="il-icon">🔐</div>
          <h1 className="il-title">Reset Password</h1>
          <p className="il-subtitle">Enter your new password below</p>
        </div>

        {!token ? (
          <div className="il-form">
            <div className="il-alert il-alert--error">
              Invalid reset link. Please request a new password reset from the login page.
            </div>
            <p className="il-hint" style={{ textAlign: 'center', marginTop: 16 }}>
              <Link className="il-link" to="/instructor-login">← Back to Sign In</Link>
            </p>
          </div>
        ) : isSuccess ? (
          <div className="il-form">
            <div className="il-alert il-alert--success">{msg}</div>
            <p className="il-hint" style={{ textAlign: 'center', marginTop: 16 }}>
              <Link className="il-link" to="/instructor-login">Sign In →</Link>
            </p>
          </div>
        ) : (
          <form className="il-form" onSubmit={handleSubmit} noValidate>
            {msg && <div className="il-alert il-alert--error">{msg}</div>}

            <div className="il-field">
              <label className="il-label">New Password</label>
              <input
                className="il-input"
                type="password"
                placeholder="Minimum 8 characters"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="il-field">
              <label className="il-label">Confirm New Password</label>
              <input
                className="il-input"
                type="password"
                placeholder="Re-enter your new password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            <button className="il-btn" type="submit" disabled={loading}>
              {loading ? <span className="il-spinner" /> : 'Reset Password'}
            </button>

            <p className="il-hint" style={{ textAlign: 'center' }}>
              <Link className="il-link" to="/instructor-login">← Back to Sign In</Link>
            </p>
          </form>
        )}
      </div>

      <p className="il-footer-note">Fast Track Driving School UK · Instructor Portal</p>
    </div>
  );
};

export default InstructorResetPassword;
